import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from '../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from '../../../../shared/util/util';
import Multiselect from 'vue-multiselect'
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import BookingService from '../../../../cargobooking/services/cargobooking.service';
import ClientService from '../../../../clientmanagement/services/clientmanagement.service';
import draggable from 'vuedraggable';
const moment = require('moment');
import uploadrequestedroute from './../uploadrequestedroute';

export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
	Multiselect,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
    TripServices,
	draggable,
	uploadrequestedroute
  },
  props: ['selectedEditRowData'],
  data() {
    return {
      isLoading:false,
      pickupPinCode:"",
      Location:null,
      service:"Surface",
      Product:null,
      companyNamelist:[],
	  AssignedList: [],
	  AssignedSR: null,
      companyName:'',
	  userRoleFlag: '',
	  clientid: '',
	  sourcepincodeerrmsg: '',
      destinationpincodeerrmsg: '',
      clientbusinessaccid: '',
	  clientName:'',
	  defaultHubID: '',
	  PinCode:'',
	  LocationName: "",
	  editLocation:false,
	  RequestedPickupDate: Util.getCurrentDateOnly(),
	  editBasicDetailsflag: false,
	  todaysDate:'',
	  clientbusinessaccountid:'',
	  clientbusinessdetailid:'',
	  uploadcsv: false,
	  businessaccountname:'',
	  isBasicInfoLoading:false,
	  AddNewLocationFlag:false,
	  editCityFlag:false,
	  tabs: [
		{ key: 'First', value: 'Create Route' }
	  ],
	  currentTab: 'First',
	  componentKey:1,
      actiontype:'add',
	  disabledflag:false,
	  updateflag:false,
	  FMPincode: [],
	  fmpincode: '',
	  LMPincode: [],
	  lmpincode:'',
	  routename:"",
	  myArray:[
		{ key: 'First', name: 'Create Route' },
	  ],
      dragging: false,
	  hubnamelist:[],
	  selectedHub:{value:'',text:''},
	  hubname: null,
	  editfmpincode:false,
	  editlmpincode:false,
	  clientName: [],
	  companyNamelistall:[],
	  routeData: {
		clientid: '',
		clientbusinessaccid: '',
		companyName: '',
		fmpincode:'',
		lmpincode:''
	  },
	  routedetails: {
        clinetlist: [],
        FMPincodelist: [],
        LMPincodelist: [],
      },
      form:[],
	  routedetails :[],
	  editroutedata: false,
	  editindex: -1,
	  editCompanyData: null,
	  editFMPincodelist: [],
	  editfmpincodelist: '',
	  editLMPincodelist: [],
	  editlmpincodelist:'',
	  editfmpincodeflag:false,
	  editlmpincodeflag:false,
	  routeid:"",
	  hubpincodelist: {fmpincode:[], lmpincode:[]},
	  fmPincodeList: [],
	  lmPincodeList: [],
	  fmpincodeselected:null,
	  lmpincodeselected:null,
	  hidelastrow:false,
	  isLoadingSelect:false,
	  filterCompanyNamelist:[]

    }
  },
  computed: {
	currentTabComponent: function () {
		this.componentKey += 1;
		this.uploadcsv = false;
		return this.currentTab.toLowerCase();
	  }
  },
	watch: {
		editindex() {
			this.$nextTick(() => { this.filterSectionHeight(); });
		},
		editFMPincodelist() {
			this.$nextTick(() => { this.filterSectionHeight(); });
		},
		editLMPincodelist() {
			this.$nextTick(() => { this.filterSectionHeight(); });
		},
		hidelastrow() {
			this.$nextTick(() => { this.filterSectionHeight(); });
		}
	},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID;
	this.userRoleFlag = (userdetail.rolename == "Admin" || userdetail.rolename == "Cargo Controlling Tower") ? 1:2;
    this.HubId = userdetail.hubID[0];
    this.HubName = userdetail.currentHubName;
    // this.HubId = 24;
	if(this.selectedEditRowData && this.selectedEditRowData.action === 'edit'){
		this.routeid = Number(this.selectedEditRowData.id)
		this.updateflag = true;
		this.hidelastrow=true;
		this.hubname = {
			value: this.selectedEditRowData.hubid,
			text: this.selectedEditRowData.hubname
		}
		this.gethubpincode(this.hubname)
		this.routename = this.selectedEditRowData.routename
		this.routeData.companyName = this.selectedEditRowData.clientName
		this.routedetails = this.selectedEditRowData.routedetails
		this.showRouteEdit(this.routedetails);
	}
	this.todaysDate = Util.getCurrentDateOnly();	
	this.getCompanyShortName();
	this.getSRListing();
	this.getHubList(); 
	this.filterSectionHeight()
  },
  methods: {
	addFMPincode(){
		if(this.fmpincode && this.fmpincode.match(/^[1-9]{1}[0-9]{5}$/)){
			if(this.FMPincode.includes(this.fmpincode)){
				this.$alertify.error("Pincode already exist")
				this.fmpincode=""
				return false
			}
			if (this.hubpincodelist.fmpincode.includes(Number(this.fmpincode))) {
				this.FMPincode.push(this.fmpincode)
			} else {
				this.$alertify.error(`Pincode ${this.fmpincode} Does not belongs to ${this.hubname?this.hubname.text: 'selected'} Hub.`)
				this.fmpincode=""
				return false
			}
			this.fmpincode=""
			this.editfmpincode = true;
		}else{
			if (this.fmpincode.length == 6) {
				return this.$alertify.error("Please enter a valid pincode");
			}
		}
	},
	addLMPincode(){
		if(this.lmpincode && this.lmpincode.match(/^[1-9]{1}[0-9]{5}$/)){
			if(this.LMPincode.includes(this.lmpincode)){
				this.$alertify.error("Pincode already exist")
				this.lmpincode=""
				return false
			}
			if (this.hubpincodelist.lmpincode.includes(Number(this.lmpincode))) {
				this.LMPincode.push(this.lmpincode)
			} else {
				this.$alertify.error(`Pincode ${this.lmpincode} Does not belongs to ${this.hubname?this.hubname.text: 'selected'} Hub.`)
				this.lmpincode=""
				return false
			}
			this.lmpincode=""
			this.editlmpincode = true;
		}else{
			if (this.lmpincode.length == 6) {
				return this.$alertify.error("Please enter a valid pincode");
			}
		}
	},
	removeFMPincode(data){
		const index = this.FMPincode.indexOf(data);
		if (index > -1) { 
		  this.FMPincode.splice(index, 1);
		}
	},
	removeLMPincode(data){
		const index = this.LMPincode.indexOf(data);
		if (index > -1) { 
		  this.LMPincode.splice(index, 1); 
		}
	},
	removeRequestClient(data){
		const index = this.companyName.findIndex(value=> {
			return value.CompanyName == data.CompanyName
		});
		if (index > -1) { 
		  this.companyName.splice(index, 1); 
		}
	},

	addNewRow() {
	  if(this.FMPincode.length || this.LMPincode.length || this.routeData.companyName){
		this.routeData.fmpincode = this.FMPincode.join(',')
		this.routeData.lmpincode = this.LMPincode.join(',')
		this.routeData.clientid = (this.routeData.companyName && this.routeData.companyName.id) ? this.routeData.companyName.id :''
		this.routeData.clientbusinessaccid = (this.routeData.companyName && this.routeData.companyName.ClientBusinessAccountId) ? this.routeData.companyName.ClientBusinessAccountId:''
		this.routeData.companyname = (this.routeData.companyName && this.routeData.companyName.CompanyName) ? this.routeData.companyName.CompanyName : ''
		const index = this.form.findIndex(value=> {
			if(value.companyname == this.routeData.companyname && value.companyname!="")
				return 1 
		});
		if (index > -1) { 
			this.$alertify.error("ClientName already added")
			return false 
		}else{
			this.form.push(this.routeData)
		}
		this.routeData = {
			clientid: '',
			clientbusinessaccid: '',
			companyName: '',
			fmpincode: '',
			lmpincode: '',
		}
		this.companyName = ''
		this.FMPincode = []
		this.LMPincode = []
		this.editfmpincode = false;
		this.editlmpincode = false;
	  }else{
		this.$alertify.error("Please select atleast one value")
		return false;
	  }

	  },
	  deleteRow(index) {
		console.log(this.form);
		this.$confirm(`You are going to delete Priority ${index+1}. Please confirm.`, '', 'question').then(() => {
		  this.form.splice(index, 1);
		  if (this.form.length==0) {
			this.hidelastrow=false;
		  }
		});

	  },
    async showRouteEdit(routedetails){
		for(let i=0;i<routedetails.length;i++){
			this.routeData.fmpincode = routedetails[i].firstmile? routedetails[i].firstmile.join():"";
			this.routeData.lmpincode = routedetails[i].lastmile? routedetails[i].lastmile.join():"";
			this.routeData.clientid = routedetails[i].clientid
			this.routeData.clientbusinessaccid = routedetails[i].clientbusinessaccountid
			this.routeData.companyname = routedetails[i].clientname
			this.form.push(this.routeData)
			//this.FMPincode = this.routeData.fmpincode
			//this.LMPincode = this.routeData.lmpincode
		
			//const index = this.form.findIndex(value=> {
			//	return value.companyname == this.routeData.companyname
			//});
			//if(index > -1){
			//	this.form.splice(index, 0, this.routeData.fmpincode)
			//	this.form.splice(index, 0, this.routeData.lmpincode)
			//}else{
				
			//}
			
			this.routeData = {
				clientid: '',
				clientbusinessaccid: '',
				companyname: null,
				companyName: null,
				fmpincode: '',
				lmpincode: '',
		    }
		this.FMPincode = []
		this.LMPincode = []
		this.editfmpincode = false;
		this.editlmpincode = false;
		}
		//this.editroutedata = true;
		//this.editfmpincode = true
		//this.editlmpincode = true
	},
	async removeRouteList(data){

		await this.$fire({
			//$Priority ${data.routeid}$
			text: `You are going to delete it.Please confirm`,
			type: 'question',
			showCancelButton: true,
			confirmButtonText: 'Confirm',
			cancelButtonText: 'Cancel'
		  }).then((result) => {
			if(result.value == true) {
				const index = this.list.findIndex(value=> {
					return value.routename == data.routename
				});
				if (index > -1) { 
				  this.list.splice(index, 1); 
				}
			}
		  }).catch((err)=>{
		   console.log(err)
		  })
	},
	addNewRowNew() {
		this.hidelastrow=false;
	},
	resetFilter(){
		this.hidelastrow=true;
		this.FMPincode =[];
		this.LMPincode=[]
		this.routeData = {
			clientid: '',
			clientbusinessaccid: '',
			companyName: '',
			fmpincode: '',
			lmpincode: '',
		}
		this.fmpincode='';
		this.lmpincode='';
		// this.routename =''
		// this.hubname = ''
		// this.companyName = ''
		// this.FMPincode = ''
		// this.LMPincode = ''
		// this.fmpincode = ''
		// this.lmpincode = ''
	},
    callParent() {
		this.startTrip = false;
		this.showAddShipment	= false
    },
    showRoutelist() {
		this.$emit("goBackToParent")
    },
    selectedservice(){},

	async getHubList(){
        try{
          let input = {}
		  let tempArr = [];
		  if( this.userRoleFlag ==1){
			let result = await  TripServices.GetHublist(input);
			let HubList = result.data.data.data;
		    for (var i = 0; i < HubList.length; i++) {
			  tempArr.push({
			    'value': HubList[i].HubID,
			     'text': HubList[i].HubName
			  });
		    }
		  }else{
			tempArr.push({
				'value':this.HubId,
				'text':this.HubName
			})
		  }
		  this.hubnamelist = tempArr
        } catch(err){
         this.isLoading = false;
          console.log(err);
        }
      },
	  selectHub(data){
		this.selectedHub = data;
        this.hubname = data.value;
	  },
	async getCompanyShortName(){
		try {
		  let InputPayload = {};
		  var CompanyShortList = [];
		  let result = await ClientService.GetClientListByActiveContracts(InputPayload)
		  CompanyShortList = result.data.data.rows;
		  for (var i = 0; i < CompanyShortList.length; i++) {
			this.companyNamelist.push({
				'id': CompanyShortList[i].clientid,
				'label': `${CompanyShortList[i].clientshortname} (${CompanyShortList[i].clientid})`,
				'CompanyName': CompanyShortList[i].clientcompanyname,
				'ClientBusinessAccountId':CompanyShortList[i].clientbusinessaccountid
			})
		  }
		  this.filterCompanyNamelist=this.companyNamelist;
		} catch(err){
		  console.log(err);
		}
	},
	async getSRListing() {
        try {
          let InputPayload = {
            HubId: this.defaultHubID
          };
          let result = await TripServices.getSRList(InputPayload);
          let SRList = result.data.data;
          for (var i = 0; i < SRList.length; i++) {
            this.AssignedList.push({
              'id': SRList[i].userid,
              'label': SRList[i].srname + ' - '+ SRList[i].emptype +" " + '('+ SRList[i].userid + ')',
              'sremail': SRList[i].email
            });
          }
        } catch (err) {
          console.log(err);
        }
    },
	  isNumber: function(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
		  evt.preventDefault();;
		} else {
		  return true;
		}
	  },

	  isIntegerOnlty: function(evt) {
		evt = (evt) ? evt : window.event;
		var charCode = (evt.which) ? evt.which : evt.keyCode;
		if (charCode < 48 || charCode > 57) {
		  evt.preventDefault();;
		} else {
		  return true;
		}
	  },
	  UploadData() {
		this.currentTab = 2;
		this.uploadcsv = true;
	  },
	  async saveRequestRoute(){
		try {
			let inputPayload = {};
			if (this.editindex !== -1) {
				await this.editRowSave(this.editindex,{})
			}
			if (this.FMPincode.length || this.LMPincode.length || this.routeData.companyName) {
				let test = await this.addNewRow()
				if (test === false) {
					return false;
				}
			}
			if(this.routename == '' || this.routename == null){
				this.$alertify.error("Please enter route name")
				return false;
			}
			if(this.hubname == '' || this.hubname ==null){
				this.$alertify.error("Please select hubname")
				return false;
			}
			if(this.form.length == 0){
				this.$alertify.error("Please Add aleast one Route details")
				return false;
			}
			  inputPayload.routename = this.routename;
			  inputPayload.hubdetails = this.hubname.value;
			  inputPayload.hubname = this.hubname.text
			  inputPayload.clientdetails = this.form;
			  inputPayload.createdby = this.userName;
			  inputPayload.lastmodifiedby = this.userName
			  if (this.updateflag) {
				inputPayload.routeid = this.routeid;
				inputPayload.status = this.selectedEditRowData.status;
			  }
			  this.isBasicInfoLoading = true;
			  let result
			  if (this.updateflag) {
				result = await TripServices.updateRouteRequest(inputPayload);
			  } else {
				result = await TripServices.saveRouteRequest(inputPayload)
			  }
			  this.isBasicInfoLoading = false;	
			  if (result.data.code == 200) {
				  //this.$alert(result.data.message, "", "success");
				  this.$alertify.success(`Record ${this.updateflag? 'updated' :'saved'} Successfully`);
				  this.$emit("goBackToParent")
				}else{
				  document.activeElement.blur();
				  //this.$alert(result.data.message, "", "error");
				  this.$alertify.error(result.data.message);
				}
		  } catch (error) {
			console.log("Error --",error)
			  this.isBasicInfoLoading = false;
			  this.$alertify.error(error);
		  }
	  },
	  resteditdata() {
		this.editindex=-1;
		this.editCompanyData= null;
		this.editFMPincodelist=[];
		this.editfmpincodeflag = false;
		this.editLMPincodelist = [];
		this.editlmpincodeflag = false;
	  },
	  async editRow(index, item) {
		if (this.editindex !== -1) {
			this.editRowSave(this.editindex,item)
		}
		await this.resteditdata();
		this.editindex = index;
		if (item) {
			this.editCompanyData= {
				id: item.clientid,
				ClientBusinessAccountId: item.clientbusinessaccid,
				CompanyName: item.companyname,
				label: item.companyname
			  }
			if (item.fmpincode && item.fmpincode != "") {
				this.editFMPincodelist.push(...item.fmpincode.split(","))
				this.editfmpincodeflag = this.editFMPincodelist.length > 0 ? true:false;
			}
			if (item.lmpincode && item.lmpincode != "") {
				this.editLMPincodelist.push(...item.lmpincode.split(","));
				this.editlmpincodeflag = this.editLMPincodelist.length > 0 ? true:false;
			}
				
		}
		// this.filterSectionHeight(index)
	  },
	  editRowSave(index, item) {
		if (this.editFMPincodelist.length || this.editLMPincodelist.length || this.editCompanyData) {
			let data = {
				"clientid": this.editCompanyData.id,
				"clientbusinessaccid": this.editCompanyData.ClientBusinessAccountId,
				"fmpincode": this.editFMPincodelist.join(","),
				"lmpincode": this.editLMPincodelist.join(","),
				"companyname": this.editCompanyData.CompanyName
			}
			this.form[index] = data;
		} else {
			this.form.splice(index, 1);
		}
		this.resteditdata()
	  },
	  editPincode(type){
		if (type == 'fm') {
			if(this.editfmpincodelist && this.editfmpincodelist.match(/^[1-9]{1}[0-9]{5}$/)){
				if(this.editFMPincodelist.includes(this.editfmpincodelist)){
					this.$alertify.error("Pincode already exist")
					this.editfmpincodelist=""
					return false
				}
				if (this.hubpincodelist.fmpincode.includes(Number(this.editfmpincodelist))) {
					this.editFMPincodelist.push(this.editfmpincodelist)
				} else {
					this.$alertify.error(`Pincode ${this.editfmpincodelist} Does not belongs to ${this.hubname?this.hubname.text: 'selected'} Hub.`)
					this.editfmpincodelist=""
					return false
				}
				this.editfmpincode = true;
				this.editfmpincodelist=""
			}else{
				if (this.fmpincode.length == 6) {
					return this.$alertify.error("Please enter a valid pincode");
				}
			}
		} else {
			if(this.editlmpincodelist && this.editlmpincodelist.match(/^[1-9]{1}[0-9]{5}$/)){
				if(this.editLMPincodelist.includes(this.editlmpincodelist)){
					this.$alertify.error("Pincode already exist")
					this.editlmpincodelist=""
					return false
				}
				if (this.hubpincodelist.lmpincode.includes(Number(this.editlmpincodelist))) {
					this.editLMPincodelist.push(this.editlmpincodelist)
				} else {
					this.$alertify.error(`Pincode ${this.editlmpincodelist} Does not belongs to ${this.hubname?this.hubname.text: 'selected'} Hub.`)
					this.editlmpincodelist=""
					return false
				}
				this.editlmpincode = true;
				this.editlmpincodelist=""
			}else{
				if (this.fmpincode.length == 6) {
					return this.$alertify.error("Please enter a valid pincode");
				}
			}
		}
	},
	editRemovePincode(type, data){
		if (type == 'fm') {
			const index = this.editFMPincodelist.indexOf(data);
			if (index > -1) { 
				this.editFMPincodelist.splice(index, 1);
			}
		} else {
			const index = this.editLMPincodelist.indexOf(data);
			if (index > -1) { 
				this.editLMPincodelist.splice(index, 1);
			}
		}
	},
	filterSectionHeight() {
		for (let index = 0; index < this.form.length; index++) {
			let filterSectionDOM = document.getElementById(`getheight${index}`);
			let tmp = filterSectionDOM ? `${filterSectionDOM.offsetHeight}px` : `55px`;
			document.getElementById(`setheight${index}`).style.height = filterSectionDOM ? `${filterSectionDOM.offsetHeight}px` : `55px`;
		}
	},
	async gethubpincode(evt) {
		try {
			this.isLoading= true;
			this.fmPincodeList=[];
			this.lmPincodeList=[];
			this.hubpincodelist= {fmpincode:[], lmpincode:[]};
			let inputPayload= {
				HubId : [evt.value]
			}
			let result = await TripServices.getHubwisePincode(inputPayload);
			if (result.data.code == 200) {
				this.hubpincodelist =  result.data.data;
				this.checkroutepincode()
				this.hubpincodelist.fmpincode.forEach(item => {
					let tmp = {
						'id': item,
						'label': item,
					}
					this.fmPincodeList.push(tmp)
				})
				this.hubpincodelist.lmpincode.forEach(item => {
					let tmp = {
						'id': item,
						'label': item,
					}
					this.lmPincodeList.push(tmp)
				})
				this.isLoading= false;
			} else {

			}

		} catch (error) {
			
		}
	},
	async checkroutepincode() {
		try {
			if(this.form.length > 0){
				let removedpincode=[]
				let spliceindex=[]
				let tmpForm = this.form;
				for (let i = 0; i < tmpForm.length; i++) {
					let FMPincode = tmpForm[i].fmpincode.split(",")
					let LMPincode = tmpForm[i].lmpincode.split(",")
					if (FMPincode.length) {
						let tmpFMPincodeindex =[...FMPincode];
						tmpFMPincodeindex.forEach((item) => {
							if(item !== '' && !this.hubpincodelist.fmpincode.includes(Number(item))) {
								removedpincode.push(item)
								const index = FMPincode.indexOf(item);
								FMPincode.splice(index, 1);
							}
						})
						tmpForm[i].fmpincode = FMPincode.join(",")
						this.form[i].fmpincode = FMPincode.join(",")
					}
					if (LMPincode.length) {
						let tmpLMPincodeindex =[...LMPincode];
						tmpLMPincodeindex.forEach((item) => {
							if(item !== '' && !this.hubpincodelist.lmpincode.includes(Number(item))) {
								removedpincode.push(item)
								const index = LMPincode.indexOf(item);
								LMPincode.splice(index, 1);
							}
						})
						tmpForm[i].lmpincode = LMPincode.join(",")
						this.form[i].lmpincode = LMPincode.join(",")
					}
					if (!tmpForm[i].clientid && tmpForm[i].fmpincode === '' && tmpForm[i].lmpincode === '') {
						spliceindex.push(i)
					}
				}
				if (removedpincode.length) {
					let removedpincodeuniq = [...new Set(removedpincode)];
					this.$alertify.error(`Pincode ${removedpincodeuniq.join(",")} Does not belongs to ${this.hubname?this.hubname.text: 'selected'} Hub.`)
				}
				if (spliceindex.length) {
					spliceindex.forEach(item => {
						this.form.splice(item, 1);
					})
					if (this.form.length==0) {
						this.hidelastrow=false;
					}
				}
			}
		} catch (error) {
			console.log(error);
		}
	},
	selectedpincode($event, action){
		if (action=== 'fm') {
			this.fmpincode=`${$event.id}`;
			this.addFMPincode();
			setTimeout(() => {
				this.fmpincodeselected=null;	
			}, 200);
		} else if (action === 'lm') {
			this.lmpincode=`${$event.id}`;
			this.addLMPincode();
			setTimeout(() => {
				this.lmpincodeselected=null	
			}, 200);		
		} else if (action=== 'efm') {
			this.editfmpincodelist=`${$event.id}`;
			this.editPincode('fm');
			setTimeout(() => {
				this.fmpincodeselected=null;	
			}, 200);
		} else if (action === 'elm') {
			this.editlmpincodelist=`${$event.id}`;
			this.editPincode('lm')
			setTimeout(() => {
				this.lmpincodeselected=null	
			}, 200);		
		}
	},
	filterClientList(query) {
		this.isLoadingSelect = true
		if (query.length == 0) {
			this.filterCompanyNamelist=this.companyNamelist;
		} else {
			this.filterCompanyNamelist=[];
			let tempList=[]
			this.companyNamelist.forEach(item => {
				if (item.label.toLowerCase().search(query.toLowerCase())>=0 || (item.id).toString().search(query)>=0  || (item.ClientBusinessAccountId).toString().search(query)>=0) {
					tempList.push(item)
				}
			})
			this.filterCompanyNamelist = tempList.filter((obj, index) => {
				return index === tempList.findIndex(o => obj.id === o.id && obj.ClientBusinessAccountId === o.ClientBusinessAccountId);
			});
		}
		this.isLoadingSelect = false;
	},

  }
}




// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/Autoallocation/createrequestedroute/createrequestedroute.component.js